/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseAmazonItem
 */
export interface ResponseAmazonItem {
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItem
     */
    actualShippingCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItem
     */
    amazonItemName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItem
     */
    asin?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItem
     */
    expiryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItem
     */
    fnskuCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponseAmazonItem
     */
    janCodes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItem
     */
    setCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseAmazonItem
     */
    shippedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseAmazonItem
     */
    storageLocation?: string;
}

/**
 * Check if a given object implements the ResponseAmazonItem interface.
 */
export function instanceOfResponseAmazonItem(value: object): value is ResponseAmazonItem {
    return true;
}

export function ResponseAmazonItemFromJSON(json: any): ResponseAmazonItem {
    return ResponseAmazonItemFromJSONTyped(json, false);
}

export function ResponseAmazonItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAmazonItem {
    if (json == null) {
        return json;
    }
    return {
        
        'actualShippingCount': json['actual_shipping_count'] == null ? undefined : json['actual_shipping_count'],
        'amazonItemName': json['amazon_item_name'] == null ? undefined : json['amazon_item_name'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'expiryDate': json['expiry_date'] == null ? undefined : json['expiry_date'],
        'fnskuCode': json['fnsku_code'] == null ? undefined : json['fnsku_code'],
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
        'janCodes': json['jan_codes'] == null ? undefined : json['jan_codes'],
        'setCount': json['set_count'] == null ? undefined : json['set_count'],
        'shippedCount': json['shipped_count'] == null ? undefined : json['shipped_count'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'storageLocation': json['storage_location'] == null ? undefined : json['storage_location'],
    };
}

export function ResponseAmazonItemToJSON(json: any): ResponseAmazonItem {
    return ResponseAmazonItemToJSONTyped(json, false);
}

export function ResponseAmazonItemToJSONTyped(value?: ResponseAmazonItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actual_shipping_count': value['actualShippingCount'],
        'amazon_item_name': value['amazonItemName'],
        'asin': value['asin'],
        'expiry_date': value['expiryDate'],
        'fnsku_code': value['fnskuCode'],
        'image_url': value['imageUrl'],
        'jan_codes': value['janCodes'],
        'set_count': value['setCount'],
        'shipped_count': value['shippedCount'],
        'sku': value['sku'],
        'storage_location': value['storageLocation'],
    };
}

